import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { cn } from '~/lib/cn';

import { formatPercentWithDecimal } from '../utils';

interface PerformanceDeltaLabelProps {
  delta?: number;
  dateRange?: string;
  className?: string;
}

export function PerformanceDeltaLabel({
  delta,
  dateRange,
  className,
}: PerformanceDeltaLabelProps) {
  const { t } = useTranslation('label-perf');

  if (!delta) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center gap-xs text-body-xs font-bold',
        {
          'text-success-default': delta > 0,
          'text-error-default': delta <= 0,
        },
        className,
      )}
      data-testid="performance-delta-label"
    >
      <Icon type={delta > 0 ? 'caret-up' : 'caret-down'} size="sm" />
      <span>
        {formatPercentWithDecimal(delta)} {dateRange ?? null} {t('body.wow')}
      </span>
    </div>
  );
}

PerformanceDeltaLabel.displayName = 'PerformanceDeltaLabel';
